export default "__VITE_ASSET__CYWH6MOk__"